import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth-store';
import ChangePasswordForm from './ChangePasswordForm';

/** Forced first-login password change for invited members with a temporary password. */
export default function RequirePasswordChange() {
  const mustChangePassword = useAuthStore(
    (s) => s.currentUser?.mustChangePassword,
  );

  if (!mustChangePassword) {
    return <Redirect to="/" />;
  }

  return (
    <div className="sign-in-panel mx-auto w-full max-w-[450px] px-2 text-center">
      <div className="glass-panel glass-panel-interactive p-8 sm:p-10">
        <h1 className="mb-3 text-[clamp(1.35rem,2vw+0.8rem,1.85rem)] font-bold text-[#121212]">
          Choose a new password
        </h1>
        <p className="mb-8 text-sm text-[var(--muted-foreground)]">
          You signed in with a temporary password. Please set a new password to
          continue.
        </p>
        <ChangePasswordForm forced />
      </div>
    </div>
  );
}
